import Vue from 'vue';

class analyticsHelpers {
  constructor(pageName, platform, version, siteName) {
    this.analyticsData = {
      page: {
        pageInfo: {
          pageName: pageName,
          platform: platform,
          version: version,
          siteName: siteName,
          pageUrl: '',
        },
      },
      userData: {
        oktaUserId: '',
      },
      data: null,
    };
  }

  setRouteChange(routeName) {
    var url = window.location.href;
    this.analyticsData.page.pageInfo.pageName = routeName.replace('/', '');
    this.analyticsData.page.pageInfo.pageUrl = url.substring(0, url.lastIndexOf('/')) + routeName;
  }

  setCustomData(data) {
    this.analyticsData.data = data;
  }

  setUserData() {
    if (Vue.prototype.$auth.userDetails) {
      this.analyticsData.userData.oktaUserId = Vue.prototype.$auth.userDetails.sub;
    }
  }

  triggerAnalyticsEvent(name) {
    window.analyticsData = this.analyticsData;
    let event = null;
    let detail = {
      siteName: 'challenger-iol',
      actionName: name,
    };
    //if IE
    if (typeof window.CustomEvent !== 'function') {
      let params = { bubbles: false, cancelable: false, detail: detail };
      let evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('chl-iol-update', params.bubbles, params.cancelable, params.detail);
      event = evt;
    } else {
      event = new CustomEvent('chl-iol-update', {
        detail: {
          siteName: 'challenger-iol',
          actionName: name,
        },
      });
    }
    document.dispatchEvent(event);
  }
}

export default analyticsHelpers;
